<template>
    <div class="bg-white grid grid-cols-1 items-center min-w-fit text-sm">
        <div class="flex justify-start items-center h-full p-3 border-b border-next-light-gray">
            <slot name="top"></slot>
        </div>
        <div class="flex justify-start items-center h-full p-3 border-t border-next-light-gray">
            <slot name="bottom"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'CardDivisorioGrigio',
    props: {}
})
export default class CardDivisorioGrigio extends Vue {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
